import { format, parseISO, isValid } from "date-fns";
import { fr, enGB } from "date-fns/locale";

export const formatEventDate = (dateBegins, dateEnds, labels = {}, lang = "fr-fr") => {
  const locale = lang === "fr-fr" ? fr : enGB;
  const pattern = lang === "fr-fr" ? "dd-MM-yyyy" : "yyyy-MM-dd";

  const begins = parseISO(dateBegins);
  const ends = dateEnds ? parseISO(dateEnds) : null;

  if (!isValid(begins)) return null;

  const beginsFormatted = format(begins, pattern, { locale });

  if (!ends || !isValid(ends) || dateBegins === dateEnds) {
    return `${beginsFormatted}`;
  }

  const endsFormatted = format(ends, pattern, { locale });

  return `${labels?.date_from || "from"} ${beginsFormatted} ${
    labels?.date_to || "to"
  } ${endsFormatted}`;
};
